export function OutlineCotizadorVallasIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99951 11.0059H3V14.0054V18.0079H4.27133"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9976 18.002L7.72998 18.0067"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0001 10.0068V3H9.99951V13.0063H12.9979"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99914 19.0043C7.99914 20.1033 7.09721 21.0055 5.99859 21.0055C4.89997 21.0055 3.99805 20.1033 3.99805 19.0043C3.99805 18.6443 4.09879 18.294 4.26671 18.006C4.61692 17.4061 5.25498 17.0078 5.99859 17.0078C6.7422 17.0078 7.38026 17.4061 7.73048 18.006C7.89839 18.294 7.99914 18.6443 7.99914 19.0043Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M5.00534 5.00195H9.99951V11.0058H3V7.00802C3 5.8994 3.89713 5.00195 5.00534 5.00195Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 14.0039H4.93818"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9951 14.5032C20.573 14.2008 19.6854 13.6585 18.4957 13.6681C18.0015 13.6681 16.783 13.6825 16.2984 14.5032C16.0394 14.9447 15.977 15.6454 16.2984 16.1685C17.138 17.541 19.8533 16.466 20.6929 17.8338C21.0095 18.3521 20.9568 19.0576 20.6929 19.4991C20.2275 20.291 19.0762 20.3198 18.5724 20.3342C17.3587 20.363 16.4327 19.8111 16.001 19.4991"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path d="M18.4958 12.002V13.6673" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M18.4956 20.334V21.9993" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
}
